import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import * as yup from 'yup';

/** Common color HEX-code validation schema */
export const hexColorSchema = yup
  .string()
  .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, DtoMessageEnum.INVALID_HEX_COLOR);
